import React from "react";
import { WidgetDisplay as WidgetDisplayType } from "../db/state";
import PositionInput from "./SettingPositionInput";
import "./SettingWidgetDisplay.css";

type Props = {
  display: WidgetDisplayType;
  onChange: (display: Partial<WidgetDisplayType>) => void;
};

const SettingWidgetDisplay: React.FC<Props> = ({ display, onChange }) => {
  return (
    <div className="WidgetDisplay">
      {/* <PositionInput
        value={display.position}
        onChange={(position) => onChange({ position })}
      /> */}

      <label>
        Size
        <br />
        <input
          type="range"
          value={display.fontSize}
          min="2"
          max="100"
          step="2"
          onChange={(event) =>
            onChange({ fontSize: Number(event.target.value) })
          }
        />
      </label>
    </div>
  );
};

export default SettingWidgetDisplay;
